import SolutionTemplate from "./SolutionTemplate";

const ActivityTrackingSolution = () => (
  <SolutionTemplate
    eyebrow="Activity tracking"
    title="See how teams spend"
    titleGradient="their workday"
    subtitle="The lightweight desktop agent captures active apps and idle time without screenshots or keylogging. Admins get productivity breakdowns and trend reports without micromanaging."
    heroImg="/assets/img/activity_tracking.jpg"
    heroImgAlt="TimeTango activity tracking dashboard"
    chips={[
      { text: "Idle time ▼ 23% lower" },
      { text: "8.2h average active time", dot: true },
    ]}
    flowSteps={[
      { title: "Agent runs", desc: "Lightweight desktop app starts with the workday" },
      { title: "Captures activity", desc: "Active apps, idle time and work patterns are logged" },
      { title: "Insights report", desc: "Admins see productivity breakdowns per employee" },
    ]}
    capabilities={[
      { icon: "🖥", title: "Desktop agent", desc: "Lightweight app for Windows and macOS" },
      { icon: "📊", title: "App usage reports", desc: "See which apps employees use and for how long" },
      { icon: "⏸", title: "Idle detection", desc: "Track idle vs active time automatically" },
      { icon: "📸", title: "Optional screenshots", desc: "Periodic screenshot capture (configurable interval)" },
      { icon: "🔔", title: "Productivity alerts", desc: "Notify when idle time exceeds threshold" },
      { icon: "📈", title: "Trend analysis", desc: "Weekly and monthly productivity trends" },
    ]}
    benefits={[
      { title: "Not micromanagement", desc: "Aggregated insights, not keystroke logging — respects privacy." },
      { title: "App categorization", desc: "Review and categorize apps as productive, unproductive or neutral." },
      { title: "Configurable intervals", desc: "Set tracking and screenshot intervals per company policy." },
      { title: "Works with attendance", desc: "Activity data links to attendance for complete work-hour visibility." },
    ]}
    relatedSlugs={["/solutions/attendance", "/solutions/timesheet", "/solutions/leave"]}
    metaTitle="Employee Activity Tracking Software | TimeTango"
    metaDescription="Lightweight desktop activity tracker with app usage reports, idle detection and productivity analytics. Privacy-first design with configurable intervals."
  />
);

export default ActivityTrackingSolution;
